module.exports = __webpack_public_path__ + "img/bg9.01dbe316.jpg";